document.addEventListener("DOMContentLoaded", function() {
  const tabs = document.querySelectorAll(".tab-button");
  const contents = document.querySelectorAll(".tab-content");

  tabs.forEach(tab => {
    tab.addEventListener("mouseenter", function() { // hover switch
      tabs.forEach(btn => btn.classList.remove("active"));
      this.classList.add("active");

      let target = this.getAttribute("data-tab");
      contents.forEach(content => {
        content.classList.remove("active");
        if(content.id === target) {
          content.classList.add("active");
        }
      });
    });
  });
});